import React, { Component } from "react";
import LachakToranjRug from "./rugTemplates/lachakToranjRug";
import AfshanRug from "./rugTemplates/afshanRug";
import KheshtiRug from "./rugTemplates/kheshtiRug";
import RugColors from "./filters/colors";
import ModernRug from "./rugTemplates/modernRug";

export default class CarpetBody extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rotate: false,
    };
  }

  rotateHandler = (evt) => {
    this.setState({ rotate: !this.state.rotate });
  };

  render() {
    return (
      <div
        className={`min-height-for-scroll ${
          this.state.rotate ? "active" : " "
        }`}
      >
        <div className="row rotation-mobile-time mx-0">
          {/* be div payin baraye charkhesh class rotation-90 bede  */}
          <div
            className={`text-center before-body-carpet relative m-auto ${
              this.state.rotate ? "rotation-90" : "rotation-90-reverse"
            }`}
          >
            {/* color filter */}

            <div className="body-carpet">
              {/* Afshan */}
              <AfshanRug
                background={
                  this.props.globalState.afshanSelectedParts.background
                }
                border={this.props.globalState.afshanSelectedParts.border}
                show={this.props.globalState.activeCarpetType === "afshan"}
              />
              {/* Lachak-Toranj */}
              <LachakToranjRug
                background={
                  this.props.globalState.lachakToranjSelectedParts.background
                }
                border={this.props.globalState.lachakToranjSelectedParts.border}
                corner={this.props.globalState.lachakToranjSelectedParts.corner}
                toranj={this.props.globalState.lachakToranjSelectedParts.toranj}
                show={
                  this.props.globalState.activeCarpetType === "lachak-toranj"
                }
              />
              {/* Modern */}
              <ModernRug
                background={
                  this.props.globalState.modernSelectedParts.background
                }
                title={this.props.globalState.modernSelectedParts.title}
                show={this.props.globalState.activeCarpetType === "modern"}
              />
              {/* Kheshti */}
              <KheshtiRug
                background={
                  this.props.globalState.kheshtiSelectedParts.background
                }
                tile={this.props.globalState.kheshtiSelectedParts.tile}
                border={this.props.globalState.kheshtiSelectedParts.border}
                show={this.props.globalState.activeCarpetType === "kheshti"}
              />
            </div>
            <RugColors
              selectedColors={this.props.globalState.colors}
              changeHandler={this.props.filterChangeHandler}
            />
            {/* be div payin baraye charkhesh class rotation-90-btn bede  */}
            <div
              className={`body-button ${
                this.state.rotate
                  ? "rotation-90-btn"
                  : "rotation-90-btn-reverse"
              }`}
            >
              <button className="change-position" onClick={this.rotateHandler}>
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 35 35"
                  version="1.1"
                  style={{
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "1.41421",
                  }}
                >
                  <g transform="matrix(1,0,0,1,-3406.84,-3652.09)">
                    <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                      <g transform="matrix(0.653614,0,0,0.653614,6854.22,-598.724)">
                        <circle
                          cx="2280.58"
                          cy="2162.15"
                          r="26.45"
                          style={{ fill: "white" }}
                        />
                      </g>
                    </g>
                    <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                      <g transform="matrix(0.34457,0,0,0.34457,5444.56,513.827)">
                        <g transform="matrix(6.12323e-17,-1,1,6.12323e-17,8387.09,902.567)">
                          <path
                            d="M54.999,17C54.79,17 54.58,16.935 54.4,16.8L50.4,13.8C49.958,13.469 49.868,12.842 50.2,12.4C50.531,11.959 51.159,11.868 51.599,12.2L55.599,15.2C56.041,15.531 56.131,16.158 55.799,16.6C55.604,16.862 55.304,17 54.999,17Z"
                            style={{
                              fill: "rgb(222,42,53)",
                              fillRule: "nonzero",
                            }}
                          />
                        </g>
                        <g transform="matrix(6.12323e-17,-1,1,6.12323e-17,8387.09,902.567)">
                          <path
                            d="M55,17C54.848,17 54.694,16.965 54.553,16.895C54.214,16.725 54,16.379 54,16L54,14C54,7.383 48.617,2 42,2C41.447,2 41,1.552 41,1C41,0.448 41.447,0 42,0C49.72,0 56,6.28 56,14L58.4,12.2C58.841,11.867 59.468,11.957 59.799,12.4C60.131,12.842 60.041,13.469 59.599,13.8L55.599,16.8C55.424,16.932 55.212,17 55,17Z"
                            style={{
                              fill: "rgb(222,42,53)",
                              fillRule: "nonzero",
                            }}
                          />
                        </g>
                        <g transform="matrix(6.12323e-17,-1,1,6.12323e-17,8387.09,902.567)">
                          <path
                            d="M9.999,48C9.79,48 9.58,47.935 9.4,47.8L5.4,44.8C4.958,44.469 4.868,43.842 5.2,43.4C5.531,42.959 6.159,42.868 6.599,43.2L10.599,46.2C11.041,46.531 11.131,47.158 10.799,47.6C10.604,47.862 10.304,48 9.999,48Z"
                            style={{
                              fill: "rgb(222,42,53)",
                              fillRule: "nonzero",
                            }}
                          />
                        </g>
                        <g transform="matrix(6.12323e-17,-1,1,6.12323e-17,8387.09,902.567)">
                          <path
                            d="M19,60C11.28,60 5,53.72 5,46L2.6,47.8C2.158,48.133 1.532,48.042 1.201,47.6C0.869,47.158 0.959,46.531 1.401,46.2L5.401,43.2C5.704,42.973 6.11,42.937 6.448,43.105C6.786,43.275 7,43.621 7,44L7,46C7,52.617 12.383,58 19,58C19.553,58 20,58.448 20,59C20,59.552 19.553,60 19,60Z"
                            style={{
                              fill: "rgb(222,42,53)",
                              fillRule: "nonzero",
                            }}
                          />
                        </g>
                        <g transform="matrix(6.12323e-17,-1,1,6.12323e-17,8387.09,902.567)">
                          <g>
                            <path
                              d="M19,20C18.74,20 18.479,19.89 18.29,19.71C18.109,19.52 18,19.27 18,19C18,18.73 18.109,18.48 18.29,18.29C18.66,17.92 19.33,17.92 19.71,18.29C19.89,18.48 20,18.73 20,19C20,19.27 19.89,19.52 19.7,19.71C19.52,19.89 19.26,20 19,20Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M14.399,19C14.399,18.45 14.849,18 15.399,18C15.95,18 16.399,18.45 16.399,19C16.399,19.55 15.95,20 15.399,20C14.85,20 14.399,19.55 14.399,19ZM10.8,19C10.8,18.45 11.25,18 11.8,18C12.35,18 12.8,18.45 12.8,19C12.8,19.55 12.35,20 11.8,20C11.25,20 10.8,19.55 10.8,19ZM7.2,19C7.2,18.45 7.649,18 8.2,18C8.75,18 9.2,18.45 9.2,19C9.2,19.55 8.75,20 8.2,20C7.649,20 7.2,19.55 7.2,19ZM3.6,19C3.6,18.45 4.05,18 4.6,18C5.15,18 5.6,18.45 5.6,19C5.6,19.55 5.15,20 4.6,20C4.05,20 3.6,19.55 3.6,19Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M1,20C0.729,20 0.479,19.89 0.29,19.71C0.109,19.52 0,19.27 0,19C0,18.73 0.109,18.48 0.29,18.29C0.66,17.92 1.34,17.92 1.71,18.29C1.89,18.48 2,18.74 2,19C2,19.26 1.89,19.52 1.71,19.71C1.52,19.89 1.27,20 1,20Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M0,37.33C0,36.78 0.45,36.33 1,36.33C1.55,36.33 2,36.78 2,37.33C2,37.89 1.55,38.33 1,38.33C0.45,38.33 0,37.89 0,37.33ZM0,33.67C0,33.11 0.45,32.67 1,32.67C1.55,32.67 2,33.11 2,33.67C2,34.22 1.55,34.67 1,34.67C0.45,34.67 0,34.22 0,33.67ZM0,30C0,29.45 0.45,29 1,29C1.55,29 2,29.45 2,30C2,30.55 1.55,31 1,31C0.45,31 0,30.55 0,30ZM0,26.33C0,25.78 0.45,25.33 1,25.33C1.55,25.33 2,25.78 2,26.33C2,26.89 1.55,27.33 1,27.33C0.45,27.33 0,26.89 0,26.33ZM0,22.67C0,22.11 0.45,21.67 1,21.67C1.55,21.67 2,22.11 2,22.67C2,23.22 1.55,23.67 1,23.67C0.45,23.67 0,23.22 0,22.67Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M1,42C0.729,42 0.479,41.89 0.29,41.7C0.109,41.52 0,41.27 0,41C0,40.74 0.109,40.48 0.29,40.29C0.66,39.92 1.34,39.92 1.71,40.29C1.89,40.48 2,40.74 2,41C2,41.26 1.89,41.52 1.71,41.71C1.52,41.89 1.27,42 1,42Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M14.399,41C14.399,40.45 14.849,40 15.399,40C15.95,40 16.399,40.45 16.399,41C16.399,41.55 15.95,42 15.399,42C14.85,42 14.399,41.55 14.399,41ZM10.8,41C10.8,40.45 11.25,40 11.8,40C12.35,40 12.8,40.45 12.8,41C12.8,41.55 12.35,42 11.8,42C11.25,42 10.8,41.55 10.8,41ZM7.2,41C7.2,40.45 7.649,40 8.2,40C8.75,40 9.2,40.45 9.2,41C9.2,41.55 8.75,42 8.2,42C7.649,42 7.2,41.55 7.2,41ZM3.6,41C3.6,40.45 4.05,40 4.6,40C5.15,40 5.6,40.45 5.6,41C5.6,41.55 5.15,42 4.6,42C4.05,42 3.6,41.55 3.6,41Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M19,42C18.74,42 18.479,41.89 18.29,41.71C18.109,41.52 18,41.27 18,41C18,40.73 18.109,40.48 18.29,40.29C18.67,39.92 19.34,39.92 19.71,40.29C19.89,40.48 20,40.73 20,41C20,41.26 19.89,41.52 19.7,41.71C19.52,41.89 19.26,42 19,42Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M18,37.33C18,36.78 18.45,36.33 19,36.33C19.55,36.33 20,36.78 20,37.33C20,37.89 19.55,38.33 19,38.33C18.45,38.33 18,37.89 18,37.33ZM18,33.67C18,33.11 18.45,32.67 19,32.67C19.55,32.67 20,33.11 20,33.67C20,34.22 19.55,34.67 19,34.67C18.45,34.67 18,34.22 18,33.67ZM18,30C18,29.45 18.45,29 19,29C19.55,29 20,29.45 20,30C20,30.55 19.55,31 19,31C18.45,31 18,30.55 18,30ZM18,26.33C18,25.78 18.45,25.33 19,25.33C19.55,25.33 20,25.78 20,26.33C20,26.89 19.55,27.33 19,27.33C18.45,27.33 18,26.89 18,26.33ZM18,22.67C18,22.11 18.45,21.67 19,21.67C19.55,21.67 20,22.11 20,22.67C20,23.22 19.55,23.67 19,23.67C18.45,23.67 18,23.22 18,22.67Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                          </g>
                          <g>
                            <path
                              d="M42,20C41.74,20 41.479,19.89 41.29,19.71C41.109,19.52 41,19.26 41,19C41,18.74 41.109,18.48 41.29,18.29C41.66,17.92 42.34,17.92 42.71,18.29C42.89,18.47 43,18.73 43,19C43,19.27 42.89,19.53 42.7,19.71C42.52,19.89 42.26,20 42,20Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M41,37.33C41,36.78 41.45,36.33 42,36.33C42.55,36.33 43,36.78 43,37.33C43,37.89 42.55,38.33 42,38.33C41.45,38.33 41,37.89 41,37.33ZM41,33.67C41,33.11 41.45,32.67 42,32.67C42.55,32.67 43,33.11 43,33.67C43,34.22 42.55,34.67 42,34.67C41.45,34.67 41,34.22 41,33.67ZM41,30C41,29.45 41.45,29 42,29C42.55,29 43,29.45 43,30C43,30.55 42.55,31 42,31C41.45,31 41,30.55 41,30ZM41,26.33C41,25.78 41.45,25.33 42,25.33C42.55,25.33 43,25.78 43,26.33C43,26.89 42.55,27.33 42,27.33C41.45,27.33 41,26.89 41,26.33ZM41,22.67C41,22.11 41.45,21.67 42,21.67C42.55,21.67 43,22.11 43,22.67C43,23.22 42.55,23.67 42,23.67C41.45,23.67 41,23.22 41,22.67Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M42,42C41.74,42 41.479,41.89 41.29,41.71C41.109,41.52 41,41.26 41,41C41,40.74 41.109,40.48 41.29,40.29C41.66,39.92 42.33,39.92 42.71,40.29C42.89,40.48 43,40.73 43,41C43,41.27 42.89,41.52 42.7,41.71C42.52,41.89 42.26,42 42,42Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M53.75,41C53.75,40.45 54.2,40 54.75,40C55.3,40 55.75,40.45 55.75,41C55.75,41.55 55.3,42 54.75,42C54.2,42 53.75,41.55 53.75,41ZM49.5,41C49.5,40.45 49.95,40 50.5,40C51.05,40 51.5,40.45 51.5,41C51.5,41.55 51.05,42 50.5,42C49.95,42 49.5,41.55 49.5,41ZM45.25,41C45.25,40.45 45.7,40 46.25,40C46.8,40 47.25,40.45 47.25,41C47.25,41.55 46.8,42 46.25,42C45.7,42 45.25,41.55 45.25,41Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M59,42C58.74,42 58.479,41.89 58.29,41.71C58.109,41.52 58,41.26 58,41C58,40.74 58.109,40.48 58.29,40.29C58.66,39.92 59.34,39.92 59.71,40.29C59.89,40.48 60,40.74 60,41C60,41.26 59.89,41.52 59.71,41.71C59.52,41.89 59.27,42 59,42Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M58,37.33C58,36.78 58.45,36.33 59,36.33C59.55,36.33 60,36.78 60,37.33C60,37.89 59.55,38.33 59,38.33C58.45,38.33 58,37.89 58,37.33ZM58,33.67C58,33.11 58.45,32.67 59,32.67C59.55,32.67 60,33.11 60,33.67C60,34.22 59.55,34.67 59,34.67C58.45,34.67 58,34.22 58,33.67ZM58,30C58,29.45 58.45,29 59,29C59.55,29 60,29.45 60,30C60,30.55 59.55,31 59,31C58.45,31 58,30.55 58,30ZM58,26.33C58,25.78 58.45,25.33 59,25.33C59.55,25.33 60,25.78 60,26.33C60,26.89 59.55,27.33 59,27.33C58.45,27.33 58,26.89 58,26.33ZM58,22.67C58,22.11 58.45,21.67 59,21.67C59.55,21.67 60,22.11 60,22.67C60,23.22 59.55,23.67 59,23.67C58.45,23.67 58,23.22 58,22.67Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M59,20C58.74,20 58.479,19.89 58.29,19.71C58.109,19.52 58,19.26 58,19C58,18.74 58.109,18.48 58.29,18.29C58.67,17.92 59.33,17.92 59.71,18.29C59.89,18.48 60,18.74 60,19C60,19.26 59.89,19.52 59.71,19.71C59.52,19.89 59.26,20 59,20Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                            <path
                              d="M53.75,19C53.75,18.45 54.2,18 54.75,18C55.3,18 55.75,18.45 55.75,19C55.75,19.55 55.3,20 54.75,20C54.2,20 53.75,19.55 53.75,19ZM49.5,19C49.5,18.45 49.95,18 50.5,18C51.05,18 51.5,18.45 51.5,19C51.5,19.55 51.05,20 50.5,20C49.95,20 49.5,19.55 49.5,19ZM45.25,19C45.25,18.45 45.7,18 46.25,18C46.8,18 47.25,18.45 47.25,19C47.25,19.55 46.8,20 46.25,20C45.7,20 45.25,19.55 45.25,19Z"
                              style={{
                                fill: "rgb(222,42,53)",
                                fillRule: "nonzero",
                              }}
                            />
                          </g>
                        </g>
                        <g transform="matrix(6.12323e-17,-1,1,6.12323e-17,8387.09,902.567)">
                          <rect
                            x="19"
                            y="1"
                            width="23"
                            height="58"
                            style={{ fill: "rgb(222,42,53)" }}
                          />
                          <path
                            d="M43,60L18,60L18,0L43,0L43,60ZM20,58L41,58L41,2L20,2L20,58Z"
                            style={{
                              fill: "rgb(222,42,53)",
                              fillRule: "nonzero",
                            }}
                          />
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
                {/* <span>{this.props.texts["rotate"]}</span> */}
              </button>
              <button
                className="clear-background"
                onClick={this.props.partsClearHandler}
              >
                <svg
                  width="100%"
                  height="100%"
                  viewBox="0 0 35 35"
                  version="1.1"
                  style={{
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    strokeLinejoin: "round",
                    strokeMiterlimit: "1.41421",
                  }}
                >
                  <g transform="matrix(1,0,0,1,-3406.84,-3593.23)">
                    <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                      <g transform="matrix(0.653614,0,0,0.653614,6854.22,-657.591)">
                        <circle
                          cx="2280.58"
                          cy="2162.15"
                          r="26.45"
                          style={{ fill: "white" }}
                        />
                      </g>
                    </g>
                    <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                      <g transform="matrix(0.0364793,0.0364793,-0.0364793,0.0364793,8344.83,736.488)">
                        <rect
                          x="175.049"
                          y="88.525"
                          width="168.891"
                          height="199.738"
                          style={{ fill: "none" }}
                        />
                      </g>
                    </g>
                    <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                      <g transform="matrix(0.0515901,0,0,0.0515901,8334.03,743.108)">
                        <path
                          d="M28.971,299.493L95.18,365.702L201.609,365.702L231.617,335.695L112.193,216.271L28.971,299.493Z"
                          style={{
                            fill: "rgb(222,42,53)",
                            fillRule: "nonzero",
                          }}
                        />
                      </g>
                    </g>
                    <g transform="matrix(1,0,0,1,-4920.71,2854.89)">
                      <g transform="matrix(0.0515901,0,0,0.0515901,8334.03,743.108)">
                        <path
                          d="M406.795,365.702L235.551,365.702L415.282,185.973C419.968,181.285 419.968,173.688 415.282,169.002L278.887,32.607C276.635,30.357 273.584,29.093 270.401,29.093C267.219,29.093 264.167,30.357 261.917,32.607L3.516,291.009C-1.172,295.695 -1.172,303.292 3.516,307.98L81.725,386.187C83.975,388.439 87.028,389.703 90.209,389.703L406.795,389.703C413.422,389.703 418.795,384.33 418.795,377.703C418.795,371.075 413.422,365.702 406.795,365.702ZM270.4,58.064L389.824,177.488L248.588,318.724L129.165,199.3L270.4,58.064ZM201.609,365.702L95.18,365.702L28.971,299.493L112.194,216.27L231.618,335.694L201.609,365.702Z"
                          style={{
                            fill: "rgb(95,108,131)",
                            fillRule: "nonzero",
                          }}
                        />
                      </g>
                    </g>
                  </g>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
